import { useGetDocumentTagByName } from 'pages/documents_v2/hooks/useGetDocumentTagByName';

import { BlocksTagsModal } from '../../tags/BlocksTagModal';
import { useGetDocument } from '../hooks/useGetDocument';

/**
 * @param {string} tag
 * @param {function():void} handleClose
 * @param {number[]} filterByVariants array of ids
 */
export function EditTagModal({ tag, handleClose, filterByVariants = [] }) {
    const document = useGetDocument();
    const documentTag = useGetDocumentTagByName(document.id, tag);

    return (
        <BlocksTagsModal
            documentId={document.id}
            tagId={documentTag?.id}
            tagName={tag}
            closeModal={handleClose}
            filterByVariants={filterByVariants}
        />
    );
}
